module.exports = __webpack_public_path__ + "static/img/RS.81c0bb8c.jpg";